import BgPattern1 from '../assets/images/bg-pattern-home-1.svg';
// import BgPattern2 from '../assets/images/bg-pattern-home-2.svg';
import { AppHeader } from './AppHeader';
import { AppHero } from './AppHero';

export function TopSection() {
    return (
    <section className="top-section main-container bg1">
        <img src={BgPattern1} className="bg-pattern1"/>
        {/* <img src={BgPattern2} className="bg-pattern2"/> */}
        <AppHeader />
        <AppHero />
    </section>
    )
}